// src/components/HUD/HUDLogin.js
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function HUDLogin({ onLoginSuccess }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/hud/login`,
        { email, password },
        { withCredentials: true }
      );
      if (res.data.user) onLoginSuccess(res.data.user);
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#F7F6F2',
      fontFamily: 'Arial, sans-serif',
    }}>
      <div style={{
        background: '#fff', borderRadius: '12px', padding: '40px',
        width: '100%', maxWidth: '400px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
        border: '1px solid #E2E0D8',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{
            width: 48, height: 48, borderRadius: '12px',
            background: '#1D9E75', display: 'flex', alignItems: 'center',
            justifyContent: 'center', margin: '0 auto 14px', fontSize: '22px',
          }}>🏠</div>
          <h1 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#1a1a18' }}>
            HUD Analytics
          </h1>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888780' }}>
            The Joachim Group CPAs &amp; Consultants
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#5F5E5A', marginBottom: '6px' }}>
              Email Address
            </label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              required placeholder="you@hud.gov"
              style={{
                width: '100%', padding: '10px 12px', fontSize: '13px',
                border: '1px solid #D3D1C7', borderRadius: '7px',
                boxSizing: 'border-box', background: '#FAFAF8',
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#5F5E5A', marginBottom: '6px' }}>
              Password
            </label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              required placeholder="••••••••"
              style={{
                width: '100%', padding: '10px 12px', fontSize: '13px',
                border: '1px solid #D3D1C7', borderRadius: '7px',
                boxSizing: 'border-box', background: '#FAFAF8',
              }}
            />
          </div>

          {error && (
            <div style={{
              padding: '10px 12px', borderRadius: '6px', fontSize: '12px',
              background: '#FCEBEB', color: '#A32D2D',
              border: '1px solid #D85A30', marginBottom: '16px',
            }}>
              {error}
            </div>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              width: '100%', padding: '11px', borderRadius: '7px',
              border: 'none', fontSize: '13px', fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              background: loading ? '#C4C2D8' : '#1D9E75',
              color: '#fff',
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={{ textAlign: 'center', fontSize: '11px', color: '#888780', marginTop: '20px', marginBottom: 0 }}>
          Access restricted to authorized HUD reviewers only.
          <br />Contact TJG to request access.
        </p>
      </div>
    </div>
  );
}